'use strict';

var _ = require('lodash');
var ReferenceValueToggleController = function ReferenceValueToggleController($scope) {
  $scope.switchReferenceValueMode = function (value) {
    _.forEach($scope.screenState.referenceValueModes, function (referenceValueMode) {
      referenceValueMode.selected = referenceValueMode.value === value;
    });
    $scope.screenState.selectedReference = value;
  };
};
ReferenceValueToggleController.$inject = ['$scope'];
module.exports = ReferenceValueToggleController;